import React from 'react';
import { inject } from 'mobx-react';
import styled from 'styled-components';

const Image = styled.img`
  max-width: 100%;
`;

const LogoContainer = styled.div`
  align-self: center;
  justify-self: center;
  text-align: center;
`;

export default inject('creditCard')(({ creditCard }) => (
  <LogoContainer>
    <Image src={`/images/payment-icons/${creditCard.cc_type}.png`} />
  </LogoContainer>
));
